import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../../common/icon';
import { ELIGIBILITY_STEP_STATUS } from '../constants';
import { statusClassName } from '../utils';

const getEligibilityStatusDescription = (status, isAutoPayoutPaused, isAutoPayoutEnabled) => {
  switch (status) {
    case ELIGIBILITY_STEP_STATUS.CRITICAL_REQUIRED:
      return 'You aren\'t eligible to enable Auto Payouts at this time due to an active financing offer.';
    case ELIGIBILITY_STEP_STATUS.REQUIRED:
      return `Take extra steps above to ${isAutoPayoutPaused ? 'resume' : 'prepare for enabling'} Auto Payout.`;
    case ELIGIBILITY_STEP_STATUS.DONE:
    default:
      return isAutoPayoutEnabled
        ? 'Auto Payouts have been enabled!'
        : 'You can now enable Auto Commission Splits or Daily Shop Payouts for your shop.';
  }
};

const AutoPayoutEligibilityStatus = ({ status, isAutoPayoutPaused, isAutoPayoutEnabled }) => (
  <div className={classnames('c-autopayout__status', statusClassName(status))}>
    <div className={classnames('c-autopayout__status-icon', statusClassName(status))}>
      <Icon
        glyph={GLYPHS.exclamation}
        display-if={status === ELIGIBILITY_STEP_STATUS.REQUIRED}
      />
      <span display-if={status !== ELIGIBILITY_STEP_STATUS.REQUIRED}>i</span>
    </div>
    <span>{getEligibilityStatusDescription(status, isAutoPayoutPaused, isAutoPayoutEnabled)}</span>
  </div>
);

AutoPayoutEligibilityStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(ELIGIBILITY_STEP_STATUS)).isRequired,
  isAutoPayoutPaused: PropTypes.bool.isRequired,
  isAutoPayoutEnabled: PropTypes.bool.isRequired,
};

export default AutoPayoutEligibilityStatus;
